@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.qualifierContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 0 5px 15px 5px;
  height: auto;

  [data-autopilot-system-redesign='on'] & {
    padding-bottom: 0;
  }

  .filters {
    display: flex;
    gap: 10px;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
}

.buttons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.triggerCounterContainer {
  background: var(--neutral-0);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -4px;
  right: -4px;
  height: 16px;
  width: 16px;

  & > div {
    width: 16px;
    height: 16px;
  }

  @include for-phone-only {
    top: 7px;
    right: 4px;
  }
}

.spacer {
  height: 1px;
  background-color: var(--dark-4);
  margin: 4px 6px;
}

.filterButton {
  margin: 2px -2px -1px -2px;
}

.dropdownContainer {
  @include blur;
  border-radius: 6px;
  background: var(--light-60) !important;
  box-shadow: 0.5px 0.5px 0px 0px var(--light-100) inset, 0px 6px 32px 0px rgba(0, 0, 0, 0.15);
}
